// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-12 mt-20">
      <div className="container mx-auto px-4 text-center">
        <div className="flex justify-center items-center space-x-2 mb-4">
          <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-cyan-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">∑</span>
          </div>
          <h3 className="text-2xl font-bold text-white">CalcBlog</h3>
        </div>
        <p className="text-slate-300 max-w-2xl mx-auto text-lg">
          Your destination for helpful calculators and insightful articles. 
          Making complex calculations simple and accessible.
        </p>
        <div className="mt-6 pt-6 border-t border-slate-700">
          <p className="text-slate-400">
            &copy; 2025 CalcBlog. All rights reserved. 
            <span className="text-cyan-300"> Built with care for your calculations.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;